import axios from 'axios'
import Swal from 'sweetalert2';

// const axiosInstance = axios.create({
//     baseURL: 'http://13.48.159.164:8080/api'
// });
// Dont use this for testing as the app is live now.
const axiosInstance = axios.create({
  baseURL: 'http://13.50.122.252:8080/api'
});
export const authenticate = async (username, password) => {
    try {
      const response = await axiosInstance.post('/login', { username, password });
      const data = response.data.data;  
      localStorage.setItem('token', response.data.data.token);
      return data;
    } catch (error) {
      Swal.fire({
        toast: true,
        title: error?.response?.data?.message,
        icon: 'error',
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
      console.log(error?.response?.data?.message,'erorrrr');
      // Handle authentication errors
      throw new Error(error);
    }
  };

  axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  export default axiosInstance;
